var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChartBar = function SvgIconChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.625 3.75a1 1 0 0 1 1-1h5.25a1 1 0 0 1 1 1V18.5h.5a1 1 0 1 1 0 2H2.625a1 1 0 1 1 0-2h.5v-5.75a1 1 0 0 1 1-1h4.25v-3.5a1 1 0 0 1 1-1h4.25zm-5.25 10h-3.25v4.75h3.25zm10.5-9V18.5h-3.25V4.75zm-5.25 4.5v9.25h-3.25V9.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChartBar;